<template>
  <header class="topbar color-head-light-blue ">
        <nav class="navbar top-navbar navbar-expand-md navbar-light">
      <!-- ============================================================== -->
      <!-- Logo -->
      <!-- ============================================================== -->
      <div class="navbar-header color-logo-light-blue">
        <a class="navbar-brand" href="#">
          <!-- Logo icon -->
          <b>
            <img src="../../assets/images/logo.png" width="30" />
          </b>
          <!--End Logo icon -->
          <!-- Logo text -->
          <span v-if="showSidebar"
            class="dark-logo"
            style=" font-weight: 500; padding-left: 10px;"
          >
           e-Sakip <sup> <small class=" badge badge-dark" style="font-size: 9px;"> V.3.0.0 </small> </sup>
          </span>
        </a>
      </div>
      <!-- ============================================================== -->
      <!-- End Logo -->
      <!-- ============================================================== -->
      <div class="navbar-collapse">
        <!-- ============================================================== -->
        <!-- toggle and nav items -->
        <!-- ============================================================== -->
        <ul class="navbar-nav ">
          <!-- This is  -->
          <li class="nav-item">
            <a
              class="nav-link waves-effect waves-dark"
              href="javascript:void(0)"
              @click.prevent="toggleSidebar"
              style="padding-left:10px !important; padding-right: 10px !important"
            >
             
                <md-icon style="margin-top: -5px;">menu</md-icon>
             </a
            >
          </li>
          <li class="nav-item hidden-sm-down"> 
              <a class="nav-link hidden-sm-down waves-effect waves-dark" href="#" style="text-transform: uppercase; font-size: 12px; font-weight:700">
                  
                  BOGORKAB -  Sistem Akuntabilitas Kinerja Instansi Pemerintah
                    
              </a>
          </li>
         
        </ul>

        <!-- ============================================================== -->
        <!-- User profile and search -->
        <!-- ============================================================== -->

        




        <ul class="navbar-nav ml-auto">
           <li class="nav-item">
             <div class="timer-hook">
              <Countdown end="march 01, 2023"></Countdown> 
              </div>
          </li>
          <!-- ============================================================== -->
     
          <!-- ============================================================== -->
          <!-- End Comment -->
          <!-- ============================================================== -->

          <!-- Language -->
          <!-- ============================================================== -->

          <li class="nav-item dropdown  hidden-xs-down">
            <!-- <a class="nav-link dropdown-toggle waves-effect waves-dark" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <img class="flag-lang" src="{{ asset('assets/plugins/images/flags/'.$flag.'.png') }}" width="16" height="16" alt="lang" /> </a> -->

            <div
              class="dropdown-menu dropdown-menu-right animated bounceInDown"
            ></div>
          </li>

          <li class="nav-item dropdown" :class="showApp ? 'show' : ''" v-if="profile.gid == '10000' ">
            <a
              class="nav-link dropdown-toggle waves-effect waves-dark"
              href="javascript:void(0)"
              @click="toggleApp"
              data-toggle="dropdown"
              aria-haspopup="true"
              :aria-expanded="showApp"
            >
              <md-icon style="margin-top: -3px;">grid_view</md-icon>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right animated flipInX"
              :class="showApp ? 'show' : ''"
            >
              <ul class="dropdown-user">
                <li>
                  <a href="#/sximo/users"
                    ><vue-fontawesome icon="user" class="mr-1" /> Users
                    Management
                  </a>
                </li>

                <li>
                  <a href="#/sximo/groups"
                    ><vue-fontawesome icon="user-friends" class="mr-1" /> Group
                    Management
                  </a>
                </li>
                <li>
                  <a href="#/sximo/mail"
                    ><vue-fontawesome icon="envelope" class="mr-1" /> Send
                    Mail</a
                  >
                </li>
                <!--
                <li>
                  <a href="#">
                    <vue-fontawesome icon="clipboard" class="mr-1" /> Page CMS
                  </a>
                </li>
                <li>
                  <a href="#">
                    <vue-fontawesome icon="file" class="mr-1" /> Post
                    Management</a
                  >
                </li>
                <li>
                  <a href="#"
                    ><vue-fontawesome icon="file" class="mr-1" /> Post
                    Categories</a
                  >
                </li>
              -->
                <li role="separator" class="divider"></li>
                <li>
                  <a href="#/sximo/notification"
                    ><vue-fontawesome icon="clock" class="mr-1" /> Activity Logs
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li class="nav-item dropdown" :class="showMainApp ? 'show' : ''" v-if="profile.gid == '10000' ">
            <a
              class="nav-link dropdown-toggle waves-effect waves-dark"
              href="javascript:void(0)"
              @click="toggleMainApp"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <md-icon>layers</md-icon>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right animated flipInX"
              :class="showMainApp ? 'show' : ''"
            >
              <ul class="dropdown-user">
                <li>
                  <a href="#/sximo/config"
                    ><vue-fontawesome icon="desktop" class="mr-1" /> General
                    Setting
                  </a>
                </li>

                <li role="separator" class="divider"></li>

                <li>
                  <a href="#/sximo/module"
                    ><vue-fontawesome icon="fire" class="mr-1" /> Module CRUD
                    Generator</a
                  >
                </li>
            
                <li>
                  <a href="#/sximo/database"
                    ><vue-fontawesome icon="bars" class="mr-1" /> Database Table
                  </a>
                </li>
                <li role="separator" class="divider"></li>
                <li>
                  <a href="#"
                    ><vue-fontawesome icon="info" class="mr-1" /> About Sximo
                  </a>
                </li>
                <li>
                  <a href="#"
                    ><vue-fontawesome icon="trash" class="mr-1" /> Clear Log &
                    Caches
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item" v-if="profile.gid == '1'">
            <a href="#/sximo/users" class="nav-link"
              ><vue-fontawesome icon="user" class="mr-1"
            /></a>
          </li>
          <li class="nav-item">
            <a href="#/auth/login" class="nav-link"
              ><vue-fontawesome icon="power-off" class="mr-1"
            /></a>
          </li>
        </ul>
      </div>
    </nav>

  </header>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Countdown from 'vuejs-countdown'
export default {
  components: { Countdown },
  data: () => {
    return {
      showNotification: false,
      showApp: false,
      showMainApp: false,
      profile : []
    };
  },
  computed: {
    ...mapState({
      showSidebar: state => state.showSidebar
    })
  },
  mounted() {
      this.profile = JSON.parse(localStorage.getItem('profile'))
      console.log( this.profile )
  },
  methods: {
    ...mapMutations({
      toggleSidebar: "toggleSidebar"
    }),
    toggleNotification() {
      this.showNotification = !this.showNotification;
      this.showApp = false;
      this.showMainApp = false;
    },
    toggleApp() {
      this.showApp = !this.showApp;
      this.showNotification = false;
      this.showMainApp = false;
    },
    toggleMainApp() {
      this.showMainApp = !this.showMainApp;
      this.showNotification = false;
      this.showApp = false;
    }
  }
};
</script>

<style>
  .color-head-light-blue {
    background: linear-gradient(90deg, #1CB5E0 0%, #000851 100%) !important;
  }
  .color-logo-light-blue {
    background: transparent !important;
  }
  .timer-hook {
    width: 220px;
    background: yellow;
    border:solid 2px #ffb22b ;
    position: fixed;
    top:5px;
    padding: 5px 10px;
    right: 100px;
    margin:  auto;
    display: none;
  }
  .timer-hook .vuejs-countdown .digit {
    font-size: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Topbar.vue